import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import './tableStyle.scss';
import { RMCheckBoxY } from 'components/customComponents/Controls/RMCheckbox';
import { ReactComponent as ArrowDown } from 'Icons/ArrowDown.svg';
import { ReactComponent as ArrowRight } from 'Icons/ArrowRight.svg';
import { isNullOrUndefined } from 'utils/Global';
interface TableProps {
  header: Array<{ value: string; label: string }>;
  data: Array<any>;
  boldIndex?: number;
  filterDataByColumn?: boolean;
  onRowClick?: (rowData: Array<any>) => void;
  checkedRowsList?: Array<number>;
  checkBoxHandler?: (any) => void;
  groupingColumn?: Array<string>;
}

function RMTable({
  header,
  data,
  boldIndex,
  filterDataByColumn = false,
  onRowClick,
  checkedRowsList = [],
  checkBoxHandler,
  groupingColumn = [],
}: TableProps) {
  let rowNumber = 0;
  function groupBySingleField(data, field) {
    return data.reduce(function (r, a) {
      r[a[field]] = r[a[field]] || {
        data: [],
        collapse: false,
      };
      r[a[field]]['data'].push(a);
      return r;
    }, Object.create(null));
  }

  function groupByMultipleFields(data, ...fields) {
    if (fields.length === 0) {
      return;
    }
    let newData = {};
    const [field] = fields;
    newData = groupBySingleField(data, field);
    const remainingFields = fields.slice(1);
    if (remainingFields.length > 0) {
      Object.keys(newData).forEach((key) => {
        newData[key] = {
          data: groupByMultipleFields(newData[key]['data'], ...remainingFields),
          collapse: false,
        };
      });
    }

    return newData;
  }

  if (!isNullOrUndefined(groupingColumn)) {
    groupingColumn = groupingColumn.filter((item) => {
      header
        .map((headerItem) => {
          return headerItem.value;
        })
        .includes(item);
      {
        return item;
      }
    });
  }

  const processedData =
    groupingColumn.length > 0 ? groupByMultipleFields(data, ...groupingColumn) : data;
  const rowData = processedData;
  const [refresher, setRefresher] = useState(false);

  function handleRowselect(rowId) {
    const selectedRowList = checkedRowsList;
    if (selectedRowList.includes(rowId)) {
      selectedRowList.remove(rowId);
    } else {
      selectedRowList.push(rowId);
    }

    setRefresher(!refresher);
    checkBoxHandler(selectedRowList);
  }

  function ParentRow({ heading, data, level }) {
    return (
      <>
        <tr id={`exppanel-table-parentrow-${heading}`}
          className="group-heading"
          style={{ marginLeft: level * 20 }}
          onClick={() => {
            data.collapse = !data.collapse;
            setRefresher(!refresher);
          }}
        >
          {data.collapse == false ? <ArrowDown id={`exppanel-table-parentrow-arrowdown`} /> : <ArrowRight />}
          {heading}
        </tr>
        {data.collapse == false
          ? Array.isArray(data.data)
            ? getRows(data.data)
            : Object.keys(data.data).map((item, i) => {
                return (
                  <ParentRow 
                    key={`parent-row-1-${i}`}
                    heading={item}
                    data={data.data[item]}
                    level={level + 1}
                  ></ParentRow>
                );
              })
          : null}
      </>
    );
  }

  function getRows(array) {
    return Array.from({ length: array.length }).map((_, parentIndex) => {
      const id = rowNumber++;
      return (
        <tr id={`exppanel-table-row-wrapper`}
          style={{
            backgroundColor: checkedRowsList.includes(id)
              ? 'rgba(133, 186, 255, 1)'
              : null,
          }}
          className={onRowClick != null && onRowClick != undefined ? 'enabledRow' : null}
          key={parentIndex}
          onDoubleClick={
            onRowClick != null && onRowClick != undefined
              ? () => {
                  onRowClick(array[parentIndex]);
                }
              : null
          }
        >
          {groupingColumn.length > 0 ? <td id={`exppanel-table-row-${id}-groupcol`}></td> : null}
          {checkBoxHandler != null && checkBoxHandler != undefined ? (
            <td id={`exppanel-table-row-${id}-checkbox-col`}>
              <RMCheckBoxY
                isChecked={checkedRowsList.includes(id)}
                onChange={() => {
                  handleRowselect(id);
                }}
              ></RMCheckBoxY>
            </td>
          ) : null}

          {Object.entries(array[parentIndex]).map((childItem, childIndex) => {
            if (
              !filterDataByColumn ||
              header
                .map((headerItem) => {
                  return headerItem.value;
                })
                .includes(childItem[0])
            ) {
              return (
                <td id={`exppanel-table-row-${id}-cell-${childIndex}`}
                  style={childIndex == boldIndex ? { fontWeight: 'bold' } : null}
                  key={childIndex}
                >
                  {childItem[1]}
                </td>
              );
            }
          })}
        </tr>
      );
    });
  }
  return (
    <div id="exppanel-table-wrapper">
      <Table id="exppanel-table" responsive borderless>
        <thead id="exppanel-table-header"
          style={{
            backgroundColor: '#E0E0E0',
          }}
        >
          <tr id="exppanel-table-header-row">
            {groupingColumn.length > 0 ? <th id="exppanel-table-header-groupcol"></th> : null}
            {checkBoxHandler != null && checkBoxHandler != undefined ? (
              <th id="exppanel-table-header-checkbox-all">
                <RMCheckBoxY
                  isChecked={data.length == checkedRowsList.length}
                  onChange={() => {
                    if (data.length == checkedRowsList.length) {
                      checkBoxHandler([]);
                    } else {
                      checkBoxHandler(Array.from(Array(data.length).keys()));
                    }
                  }}
                ></RMCheckBoxY>
              </th>
            ) : null}

            {Array.from({ length: header.length }).map((_, index) => (
              <th id={`exppanel-table-header-col-${header[index].label}`} className="align-middle" key={index}>
                {header[index].label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody id="exppanel-table-body">
          {Array.isArray(rowData)
            ? getRows(rowData)
            : Object.keys(rowData).map((item, i) => {
                return (
                  <ParentRow 
                    key={`parent-row-${i}`}
                    heading={item}
                    data={rowData[item]}
                    level={0}
                  ></ParentRow>
                );
              })}
        </tbody>
      </Table>
    </div>
  );
}

export default RMTable;
